module.exports = __webpack_public_path__ + "img/terroir-disc-3-mobile.1b0d4729.jpg";